module.exports = __webpack_public_path__ + "img/F973.1e662c97.jpg";